<template>
	<div style="background-color: #fff;padding: 5px 10px;height: 40px;border-bottom: 1px solid #e1e1e1;">
		<el-row justify="start">
			<el-col :span="3" >
				<div>&nbsp;</div>
				<!-- <el-image style="width: 120px; height: 40px;float: left;" :src="leftlogourl" ></el-image> -->
			</el-col>
			<el-col :span="15">
				<div>&nbsp;</div>
			</el-col>
			<el-col :span="6">
				<div style="margin-top: 0px;line-height: 28px;height: 28px;float: right;margin-right: 10px;min-width: 280px;">
					<span style=""><i style="color: #797979;font-size: 20px;" class="el-icon-bell"></i></span>
					<span style="margin-left: 20px;"><i style="color: #797979;font-size: 20px;" class="el-icon-user"></i></span>
					<span style="margin-left: 5px;color: #797979;font-size: 14px;line-height: 40px;">{{userInfo.realname}}</span>
					<span style="margin-left: 10px;color: #797979;font-size: 20px;">
						<el-divider style="margin-left: 20px;" direction="vertical"></el-divider>
					</span>
					<span style="margin-left: 10px;color: #797979;font-size: 14px;" @click="changepwd">修改密码</span>
					<span style="margin-left: 10px;color: #797979;font-size: 14px;" @click="logOut">
						<i style="color: #FC988B;font-size: 20px;" class="el-icon-switch-button"></i>
						退出
					</span>
				</div>
				
			</el-col>
		</el-row>
		
	</div>
</template>

<script>
	export default {
		name : 'SysHeader',
		data() {
			return {
				bgcolor : '#FFF  !important',
				leftlogourl : "/static/img/yh-logo-1.82ac2472.png",
				isCollapse: false,
				userInfo : {
					realname : ''
				}
				
			}
		},
		mounted() {
			console.log('menu')
			let uinfo = localStorage.getItem("bUserinfo")
			console.log(uinfo)
			this.userInfo = JSON.parse(uinfo)
		},
		methods: {
			logOut(){
				console.log('退出')
				localStorage.setItem("bUserinfo", '')
				sessionStorage.setItem("authToken", '');
				this.$router.push({ name: 'Login' });
			},
			
			changepwd(){
				this.$router.push({ name: 'ChangePassword' });
				
			},
			
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	.yh-menu-icon-color{
		color: #fff;
	}
</style>